import { CanActivate, CanActivateChild } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Store } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  /**
   * @param store
   */
  constructor(
    private store: Store
  ) {}

  public canActivate(): Observable<boolean> {
    return this.isAuthorized();
  }

  public canActivateChild(): Observable<boolean> {
    return this.isAuthorized();
  }

  public isAuthorized(): Observable<boolean> {
    const result = new ReplaySubject<boolean>(1);

    this.store
      .selectOnce((state) => state.auth.isAuthorized)
      .subscribe((isAuthorized: boolean) => {
        if (!isAuthorized) {
          this.store.dispatch([ new Navigate(['/auth']) ]);
        }

        result.next(isAuthorized);
        //result.next = (true);
      });

    return result.asObservable();
  }
}
